import mainLogo from '../assets/images/main-logo.png';
import infoIcon from '../assets/images/info-icon.png';
import logo1 from '../assets/images/guess-logo1.png';
import logo2 from '../assets/images/guess-logo2.png';
import howToRed from '../assets/images/pokeball-red.png';
import statsLogoGolden from '../assets/images/stats-icon.png';
import masterBall from '../assets/images/master-ball.png';
import pokeBall from '../assets/images/pokeball.png';
import superBall from '../assets/images/super-ball.png';
import ultraBall from '../assets/images/ultra-ball.png';
import historyIcon from '../assets/images/history-icon.png';
import redPng from '../assets/images/red.png';
import emojiIcon from '../assets/images/emoji-icon.png';
import playIcon from '../assets/images/play-icon.png';
import classicIcon from '../assets/images/classic-icon.png';
import earlyMorning from '../assets/images/01-Early-Morning.png';
import midMorning from '../assets/images/02-Mid-Morning.png';
import lateMorning from '../assets/images/03-Late-Morning.png';
import earlyAfternoon from '../assets/images/04-Early-Afternoon.png';
import midAfternoon from '../assets/images/05-Mid-Afternoon.png';
import lateAfternoon from '../assets/images/06-Late-Afternoon.png';
import earlyEvening from '../assets/images/07-Early-Evening.png';
import midEvening from '../assets/images/08-Mid-Evening.png';
import lateEvening from '../assets/images/09-Late-Evening.png';
import earlyNight from '../assets/images/10-Early-Night.png';
import midNight from '../assets/images/11-Mid-Night.png';
import lateNight from '../assets/images/12-Late-Night.png';
import '../assets/animations.css';

export const GetBackground = () => {
  const date = new Date();
  const hour = date.getHours();
  if (hour >= 0 && hour < 5) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${lateNight})`;
  }
  if (hour >= 5 && hour < 7) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${earlyMorning})`;
  }
  if (hour >= 7 && hour < 10) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${midMorning})`;
  }
  if (hour >= 10 && hour < 12) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${lateMorning})`;
  }
  if (hour >= 12 && hour < 14) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${earlyAfternoon})`;
  }
  if (hour >= 14 && hour < 16) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${midAfternoon})`;
  }
  if (hour >= 16 && hour < 18) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${lateAfternoon})`;
  }
  if (hour >= 18 && hour < 19) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${earlyEvening})`;
  }
  if (hour >= 19 && hour < 20) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${midEvening})`;
  }
  if (hour >= 20 && hour < 21) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${lateEvening})`;
  }
  if (hour >= 21 && hour < 23) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${earlyNight})`;
  }
  if (hour >= 23 && hour < 24) {
    return `linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${midNight})`;
  }
};

export const logos = {
  mainLogo,
  infoIcon,
  logo1,
  logo2,
  howToLogoRed: howToRed,
  statsLogoGolden,
  masterBall,
  pokeBall,
  superBall,
  ultraBall,
  historyIcon,
  redPng,
  playIcon,
  classicIcon,
  emojiIcon,
};
